import { all } from 'redux-saga/effects'
import { chatsSaga } from './chats/sagas'
import { conversationSaga } from './conversation/sagas'
import { socketSaga } from './socket/sagas'

export function* chatSaga() {
  yield all([chatsSaga(), conversationSaga(), socketSaga()])
}
